import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const SchemaEditPage = lazy(() =>
  import('@/features/schemas/components/SchemaEditPageWrapper').then((m) => ({
    default: m.SchemaEditPageWrapper,
  })),
);

export const schemaEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/schemas/$type/edit',
  component: SchemaEditPage,
});
